// src/features/streams/components/StreamHeader.tsx

import { Group, Stack, Text, Badge, Anchor } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { MediaStatusBadge } from '@/features/media/components/MediaStatusBadge';
import { StreamLiveStatusBadge } from './StreamLiveStatusBadge';
import { StreamActionsGroup } from './StreamActionsGroup';
import { STREAM_TYPE_LABELS } from '@/lib/constants/stream';
import type { StreamViewData, StreamLiveStatus } from '@/lib/types/Stream';
import type { StreamType } from '@/lib/constants/stream';
import type { IBackendLiveData } from '@/lib/types/Customer';

interface StreamHeaderProps {
  stream: StreamViewData;
  displayId: string;
  liveStatus: StreamLiveStatus;
  backendMap: Map<number, IBackendLiveData>;
}

export function StreamHeader({ stream, displayId, liveStatus, backendMap }: StreamHeaderProps) {
  const media = stream.media;
  const streamType = (stream.stream?.core?.streamType ?? 'push') as StreamType;

  return (
    <Stack gap="xs">
      <Anchor component={Link} to="/streams" size="sm" c="dimmed">
        <Group gap={4}>
          <IconArrowLeft size={14} />
          Back to Streams
        </Group>
      </Anchor>

      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Text fw={700} size="xl">{media.title}</Text>
          <Group gap="sm">
            <Text size="sm" c="dimmed">ID: {displayId}</Text>
            <Text size="sm" c="dimmed">·</Text>
            <MediaStatusBadge status={media.mediaStatusType} state={media.mediaStateType} />
            <Text size="sm" c="dimmed">·</Text>
            <StreamLiveStatusBadge liveStatus={liveStatus} />
            <Text size="sm" c="dimmed">·</Text>
            <Badge variant="light" size="sm">
              {STREAM_TYPE_LABELS[streamType] ?? streamType}
            </Badge>
          </Group>
        </Stack>

        <StreamActionsGroup stream={stream} liveStatus={liveStatus} backendMap={backendMap} />
      </Group>
    </Stack>
  );
}
